import { render, staticRenderFns } from "./BulkCheckboxes.vue?vue&type=template&id=f12db404&scoped=true&"
import script from "./BulkCheckboxes.vue?vue&type=script&lang=ts&"
export * from "./BulkCheckboxes.vue?vue&type=script&lang=ts&"
import style0 from "./BulkCheckboxes.vue?vue&type=style&index=0&id=f12db404&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12db404",
  null
  
)

export default component.exports